import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    topImage: {
        // position: 'absolute',
        width: '472px',
        height: '552.18px',
        // left: '853.39px',
        // top: '214.39px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        // border: '2px solid #FFFFFF',
        sizing: 'border-box',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        opacity: 0.9,
        margin: '0 auto 0 auto'
    },
    leftGrid: {
        // flexGrow: 1,
        overflow: 'auto',
        maxHeight: '500px',
        // margin: '0 20px',

        // margin: '0 auto 0 auto',
        padding: '0px 60px',
        textAlign: 'center',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        border: '2px solid #FFFFFF',
    },
    rightGrid: {
        // textAlign: 'left',
        // margin: '0 auto 0 auto',
        // margin: '0 20px',
        padding: '0px !important',
        // textAlign: 'center',
        // backgroundColor: 'rgba(255,255,255,0.4)',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        // // radius: '15px',
        // borderRadius: '25px',
        // border: '2px solid #FFFFFF',
    },
    rightupGrid: {
        // textAlign: 'left',
        // margin: '0 auto 0 auto',
        // margin: '0 20px',
        // padding: '0px !important',
        // textAlign: 'center',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        // radius: '15px',
        borderRadius: '25px',
        border: '2px solid #FFFFFF',
        marginBottom: '30px'
    },
    rightdownGrid: {
        // textAlign: 'left',
        // margin: '0 auto 0 auto',
        // margin: '0 20px',
        // padding: '0px !important',
        // textAlign: 'center',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        // radius: '15px',
        borderRadius: '25px',
        border: '2px solid #FFFFFF',
    },
    sectionTitle: {
        margin: '0px auto 60px',
        padding: '0 1em 5px',
        borderBottom: '1px solid black',
        fontSize: '32px',
    },
    QA: {
        width: '100%',
        align: 'center',
        margin: '5rem auto 12rem auto',
        padding: '0px 60px',
    },
    questionDiv: {
        color: 'white',
        fontWeight: 500,
        width: '90%',
        align: 'center',
        textAlign: 'left',
        background: '#F3923D',
        // sizing: 'border-box',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        //border: '1px solid #333333',
        boxSizing: 'border-box',
        borderRadius: '15px',
        margin: '5rem auto 0.1rem auto',
        // marginTop: '15rem',
        // marginBottom: '30rem',
        // margin: '200px 50px',
        padding: '20px 20px',
        fontSize: '24px',
    },
    answerDiv: {
        color: 'black',
        fontWeight: 300,
        width: '90%',
        align: 'center',
        textAlign: 'left',
        background: 'white',
        fontFamily: 'Noto Sans JP, sans-serif',
        // sizing: 'border-box',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        //border: '1px solid #333333',
        boxSizing: 'border-box',
        borderRadius: '15px',
        margin: '0rem auto 0.1rem auto',
        // marginTop: '15rem',
        // marginBottom: '30rem',
        // margin: '200px 50px',
        padding: '20px 20px',
        fontSize: '16px',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        border: '2px solid #FFFFFF',
    },
    advisorsGrid: {
        margin: '5rem auto 12rem auto',
    },
    sectionOrangeTitle: {
        background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,
        fontFamily: 'Noto Sans JP, sans-serif',
        fontStyle: 'normal',
        //   fontDisplay: 'swap',
        fontWeight: 500,
        maxWidth: '100%',
        //marginTop: '10rem'
    },
    smallTitle: {
        // background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        // lineHeight: 1.4,
        fontFamily: 'Noto Sans JP, sans-serif',
        // fontStyle: 'normal',
        // //   fontDisplay: 'swap',
        // fontWeight: 500,
    }
    ,
    signupButton: {
        color: 'white',
        background: '#F3923D',
        borderRadius: '32.83px',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        marginRight: 25,
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    loginButton: {
        color: '#F3923D',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        // box-sizing: border-box;
        borderRadius: '32.83px',
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    topGridContainer: {
        borderRadius: 4,
        marginTop: '5rem',
        padding: '16px',
        fontFamily: 'Noto Sans JP'
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },
    sliderTab: {
        margin: '10rem auto 12rem auto',
    },
    advisorAlt: {
        width: '240px',
        height: '240px',
        // left: '208.9px';
        // top: '2919.37px';
        borderRadius: '120px',
        backgroundColor: '#C4C4C4',
        margin: '10px auto',
    },
    sponsorDiv: {
        width: '100%',
        align: 'center',
        // sizing: 'border-box',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        //border: '1px solid #333333',
        boxSizing: 'border-box',
        borderRadius: '32.83px',
        margin: '5rem auto 15rem auto',
        backgroundColor: 'white',
        // marginTop: '15rem',
        // marginBottom: '30rem',
        // margin: '200px 50px',
        padding: '140px 60px',
    },
    sponsorLogos: {
        height: 120,
    },
    carouselsGrid: {
        margin: "0px auto !important",
        width: "700px"
    },
    carouselTitle: {
        borderBottom: "1px solid black",
        marginBottom: "30px"
    },
    newsGridContainer: {},
    projectsGridContainer: {
        marginTop: "100px",
        marginBottom: "100px"
    },
    joinGridContainer: {},
    projectRecommendation: {
        margin: "40px"
    },
    viewProjects: {
        margin: "30px 30px",
        color: "white",
        width: "200px"
    }


}));